import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { type TierPayoutTerms } from '../domain/types';
import { affiliateManagementService } from '../infra/affiliateManagementService';

interface UsePayoutTermsByTierParams {
  projectId: string;
  tierIds: string[];
}

interface UsePayoutTermsByTierResult {
  tierPayoutTerms: TierPayoutTerms[];
  isLoading: boolean;
  isError: boolean;
}

export const usePayoutTermsByTier = ({
  projectId,
  tierIds,
}: UsePayoutTermsByTierParams): UsePayoutTermsByTierResult => {
  const {
    data: response,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['affiliate-management', 'payout-terms-by-tier', projectId, tierIds],
    queryFn: () => affiliateManagementService.getPayoutTermsByTier(projectId, tierIds),
    enabled: !!projectId && tierIds.length > 0,
  });

  const tierPayoutTerms = useMemo(() => response?.tiers ?? [], [response]);

  return { tierPayoutTerms, isLoading, isError };
};
